async function getCartHTML() {
	const url = `${window.Shopify.routes.root}?sections=header`;

	const responce = await fetch(url);
	if (responce.status === 200) {
		const result = await responce.json();

		let source = new DOMParser()
			.parseFromString(result.header, 'text/html')
			.getElementById('cart-popup');

		const current_cart = document.getElementById('cart-popup');
		current_cart.innerHTML = source.innerHTML;
	}
}

window.addEventListener('pageshow', (event) => {
	if (event.persisted) {
		getCartHTML();
		const cards = document.querySelectorAll('.product-card');
		if (cards.length > 0) {
			cards.forEach((card) => {
				if (card.classList.contains('active')) {
					card.classList.remove('active');
				}
			});
		}
	}
});
